import { MojoActivityTrackingConfig } from 'mojo-activity-tracking';
import { environment } from '@env/environment';
import {
  associationsClear,
  associationStatusConfigurationsLoad,
  getJobAssociationStatusConfigurations,
} from '@modules/assigns/store';
import {
  attachmentsClear,
  attachmentsGetLatestCoverLetter,
  attachmentsGetLatestCoverLetterFailure,
} from '@collections/attachments';
import { addMainOutletRoute } from '@shared/navigation-history/navigation-history.actions';
import {
  collectionCandidatesClear,
  jobCandidatesClear,
  loadDirectCandidatesNumberPerPhase,
} from '@modules/job-page/store';
import { candidatesPageClear, candidatesSimilarClear } from '@modules/candidates/store';
import { collectionAssociationsClear } from '@collections/associations';
import {
  jobFilterSet,
  jobFilterSetInitialState,
  jobFilterSetInitialStateSuccess,
} from '@modules/job-page/store/matched-candidates-filter';
import { resetTasksState } from 'mojo-tasks';
import { mojoNotesReset } from 'mojo-irp-notes';
import { UsersActionTypes } from '@collections/users';

export const activityTrackingConfig: MojoActivityTrackingConfig = {
  baseUrl: environment.API_BASE_URL,
  productName: 'irp-ui',
  blacklistedPatterns: [
    /^@ngrx\//,
    /^\[Shared Resources\]/,
    /^\[mojo-common-ui\]\[FeatureFlags\]/,
    /^\[License Configuration\]/,
    /^\[Avatar\]/,
    /^\[Roles\]/,
    /^\[Association Label\]/,
    /^\[Websocket\]/,
    /^\[Alert\]/,
    /^\[Modal\]/,
    /^\[Form\]/,
    /^\[CandidatesForm\]/,
    /^\[Notifications\]/,
    /^\[Aggregation\]/,
    /^\[Managers\]/,
    /^\[Notes\]/,
    /^\[Notes Filters\]/,
    /success$/i,
  ],
  blacklistedActionTypes: [
    associationStatusConfigurationsLoad.type,
    getJobAssociationStatusConfigurations.type,
    associationsClear.type,
    jobCandidatesClear.type,
    candidatesPageClear.type,
    collectionCandidatesClear.type,
    collectionAssociationsClear.type,
    attachmentsGetLatestCoverLetter.type,
    attachmentsGetLatestCoverLetterFailure.type,
    addMainOutletRoute.type,
    jobFilterSet.type,
    jobFilterSetInitialState.type,
    jobFilterSetInitialStateSuccess.type,
    loadDirectCandidatesNumberPerPhase.type,
    candidatesSimilarClear.type,
    resetTasksState.type,
    mojoNotesReset.type,
    attachmentsClear.type,
    UsersActionTypes.Get,
  ],
};
